import { useEffect, useState } from "react"
import { getPlayerGpsOnce, PlayerGps, watchPlayerGps } from "@/utils/playerGps"

export function usePlayerGpsState() {
  const [gps, setGps] = useState<PlayerGps | null>(null)

  useEffect(() => {
    void getPlayerGpsOnce().then(setGps)
    return watchPlayerGps(setGps)
  }, [])

  return gps
}
